import HotelList from "../components/HotelList";
import { Helmet } from "react-helmet-async";

export default function Hotels() {
    return (

        <>
            <Helmet>
                <title>
                    Hotels in Dubai | Beach Hotels Dubai
                </title>

                <meta
                    name="description"
                    content="Browse cheap hotels, budget stays, apartments, and affordable accommodations in Dubai with Beach Hotels Dubai."
                />

                <link
                    rel="canonical"
                    href="https://beachhotelsdubai.com/hotels"
                />

                {/* Open Graph */}
                <meta
                    property="og:title"
                    content="Hotels in Dubai | Beach Hotels Dubai"
                />

                <meta
                    property="og:description"
                    content="Browse cheap hotels, budget stays, apartments, and affordable accommodations in Dubai with Beach Hotels Dubai."
                />

                <meta
                    property="og:url"
                    content="https://beachhotelsdubai.com/hotels"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                {/* Twitter */}
                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="Hotels in Dubai | Beach Hotels Dubai"
                />

                <meta
                    name="twitter:description"
                    content="Browse cheap hotels, budget stays, apartments, and affordable accommodations in Dubai with Beach Hotels Dubai."
                />

                <meta
                    name="robots"
                    content="index, follow"
                />
            </Helmet>

            <div>
                <HotelList showSidebar={true} showBanner={true} showHeading={false} />
            </div>
        </>
    );
}